export default __webpack_public_path__ + "static/media/O-023.aa2a073d.png";